import { Injectable, computed, signal } from '@angular/core';
import { ICE_DASHBOARD_TOKEN_KEY, IDENTITY_TOKEN_KEY, TOKEN_KEY } from 'shared/constants/general-constants';
import { StorageService } from 'shared/services';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    private _token = signal<string | undefined>(undefined);
    public token = computed(() => this._token());

    private _iceDashboardToken = signal<string | undefined>(undefined);
    public iceDashboardToken = computed(() => this._iceDashboardToken());

    private _identityToken = signal<string | undefined>(undefined);
    public identityToken = computed(() => this._identityToken());

    constructor(private storageService: StorageService) {
        this.loadTokensFromStorage();
    }

    public setToken(value: string | null | undefined): void {
        if (!value) {
            this.storageService.removeFromLocal(TOKEN_KEY);
            this._token.set(undefined);
        } else {
            this.storageService.setInLocal(TOKEN_KEY, value);
            this._token.set(value);
        }
    }

    public setIceDashboardToken(value: string | null | undefined): void {
        if (!value) {
            this.storageService.removeFromLocal(ICE_DASHBOARD_TOKEN_KEY);
            this._iceDashboardToken.set(undefined);
        } else {
            this.storageService.setInLocal(ICE_DASHBOARD_TOKEN_KEY, value);
            this._iceDashboardToken.set(value);
        }
    }

    public setIdentityToken(value: string | null | undefined): void {
        if (!value) {
            this.storageService.removeFromLocal(IDENTITY_TOKEN_KEY);
            this._identityToken.set(undefined);
        } else {
            this.storageService.setInLocal(IDENTITY_TOKEN_KEY, value);
            this._identityToken.set(value);
        }
    }

    private loadTokensFromStorage(): void {
        const storedToken = this.storageService.getFromLocal(TOKEN_KEY) as string | undefined;
        const storedIdentityToken = this.storageService.getFromLocal(IDENTITY_TOKEN_KEY) as string | undefined;

        if (storedToken) {
            this._token.set(storedToken);
        }

        if (storedIdentityToken) {
            this._identityToken.set(storedIdentityToken);
        }
    }
}
